import { Picture } from "@/components/media/Picture";

/**

 * Full-height photo hero used by interior pages, matching the source site:
 * centered title with optional verse lines over a scrimmed background photo.
 */
export function PageHero({
  title,
  image,
  eyebrow,
  subtitle,
  attribution,
  height = "tall",
}: {
  title: string;
  image: string;
  eyebrow?: string;
  subtitle?: string;
  attribution?: string;
  height?: "tall" | "short";
}) {
  return (
    <section
      aria-label={title}
      className={
        height === "tall"
          ? "relative flex min-h-[70svh] items-center justify-center overflow-hidden sm:min-h-[85dvh]"
          : "relative flex min-h-[50svh] items-center justify-center overflow-hidden sm:min-h-[55dvh]"
      }
    >
      <Picture
        src={image}
        alt=""
        sizes="100vw"
        fetchPriority="high"
        decoding="async"
        width={1600}
        height={800}
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div className="hero-scrim absolute inset-0" aria-hidden />
      <div className="container-site relative max-w-3xl py-20 text-center sm:py-24">
        {eyebrow ? <p className="eyebrow mb-4 text-sm text-white/90">{eyebrow}</p> : null}
        <h1 className="text-4xl text-white sm:text-6xl">{title}</h1>
        {subtitle ? <p className="mt-6 text-lg text-white sm:text-xl">{subtitle}</p> : null}
        {attribution ? <p className="mt-4 text-lg text-white sm:text-xl">{attribution}</p> : null}
      </div>
    </section>
  );
}
